export const basePageUrl = '/';
export const editorPageUrl = '/editor/';
export const oldBasePageUrl = '/old/';
export const newBasePageUrl = '/new/';
export const fontCreatorPageUrl = '/font-creator/';
export const offerPageUrl = '/offer/';
export const policyPageUrl = '/policy/';
export const faqPageUrl = '/faq/';
export const profilePageUrl = '/profile/';
export const resetPasswordPageUrl = '/reset-password/';
export const pricingPageUrl = '/pricing/';
export const privacyPageUrl = '/privacy/';
export const refundPageUrl = '/refund/';
export const termsPageUrl = '/terms/';
export const aiPageUrl = '/ai/';
export const paymentPageUrl = '/payment/';
export const flashcardsPageUrl = '/materials/';
export const flashcardsTopicPageUrl = '/materials/:topicId';
export const recognizePageUrl = '/recognize/';
export const photoToTextPageUrl = '/photo-to-text/';
export const audioToTextPageUrl = '/audio-to-text/';
export const youtubeToTextPageUrl = '/youtube-to-text/';
export const pdfToTextPageUrl = '/pdf-to-text/';
